var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lobby-list"},[_c('Header',{attrs:{"title":"Últimas partidas","subtitle":"públicas"}}),_c('div',{staticClass:"container"},[_c('LobbiesTable',{attrs:{"lobbies":_vm.lobbies}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }